import { useState, useEffect, useRef } from 'react'

import LactationService from 'service/LactationService'

export default function useGetLactationLocationList() {
  const [data, updateData] = useState<any[]>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)
  const isMountedRef = useRef(true)

  function fetchData() {
    if (!isMountedRef.current) return
    setIsLoading(true)
    LactationService.getLactationLocations()
      .then((r) => {
        if (isMountedRef.current) {
          updateData(r.data)
        }
      })
      .catch((err) => {
        if (isMountedRef.current) {
          setError(true)
        }
      })
      .finally(() => {
        if (isMountedRef.current) {
          setIsLoading(false)
        }
      })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchData()
    return () => {
      isMountedRef.current = false
    }
  }, [])

  return { data, isLoading, error }
}
